import qs from 'query-string';
import { prop, omit } from 'ramda';

import { APPROVALS, REFERRAL } from 'store/diagnoses';

import { wrapperRequest } from './utils';
import { API_URL, POST, PATCH, SUB_USER, SUB_EXAMINATION, EXPAND, LIMIT, SUB_PHYSICIAN, SUB_ORGANIZATION } from './consts';

const defParams = { [EXPAND]: [`${APPROVALS}.${SUB_USER}`, SUB_PHYSICIAN, `${REFERRAL}.${SUB_ORGANIZATION}`] };

export const getExaminationDiagnosis = (id) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses?${qs.stringify({ [SUB_EXAMINATION]: id, ...defParams })}`,
  });

export const patchDiagnosis = (body = {}) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses/${prop('diagnosisId', body)}?${qs.stringify(defParams)}`,
    options: { method: PATCH, body: omit(['diagnosisId'], body) },
  });

export const getDiagnosisReports = (id) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses/${id}/reports?${qs.stringify({ [LIMIT]: 50 })}`,
  });

export const getDiagnosisReportPreview = ({ diagnosisId, contact }) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses/${diagnosisId}/issue/preview`,
    options: { method: POST, body: { receiverType: contact } },
    downloadFile: true,
  });

export const getDiagnosisCodes = () =>
  wrapperRequest({
    url: `${API_URL}/diagnosiscodes?${qs.stringify({ [LIMIT]: 50 })}`,
  });

export const postDiagnosisWithdraw = (id) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses/${id}/withdraw?${qs.stringify(defParams)}`,
    options: { method: POST, body: {} },
  });

export const postDiagnosisIssue = (id) =>
  wrapperRequest({
    url: `${API_URL}/diagnoses/${id}/issue?${qs.stringify(defParams)}`,
    options: { method: POST, body: {} },
  });
